const { createSelector } = require('reselect')

//emailOtp
const selectEmailOtp = (state) => state.userDomain.emailOtp;

const emailOtp = () => createSelector([selectEmailOtp], (prf) => prf.data);

const emailOtpError = () =>
  createSelector([selectEmailOtp], (prf) => prf.error);

const emailOtpLoading = () =>
  createSelector([selectEmailOtp], (prf) => prf.loading);

//


const selectloggedInUser = state => state.userDomain.loggedInUser
const getLoggedInUser = () => createSelector([selectloggedInUser], prf => prf.data)
const getLoggedInUserError = () => createSelector([selectloggedInUser], prf => prf.error)
const getLoggedInUserLoading = () => createSelector([selectloggedInUser], prf => prf.loading)

const selectPostUser = state => state.userDomain.postUser
const getPostUser = () => createSelector([selectPostUser], cse => cse.data)
const getPostUserError = () => createSelector([selectPostUser], cse => cse.error)
const getPostUserLoading = () => createSelector([selectPostUser], cse => cse.loading)

const selectImportUser = state => state.userDomain.importUser
const getImportUser = () => createSelector([selectImportUser], cse => cse.data)
const getImportUserError = () => createSelector([selectImportUser], cse => cse.error)
const getImportUserLoading = () => createSelector([selectImportUser], cse => cse.loading)

const selectAllUsersList = state => state.userDomain.allUsersList
const getAllUsersList = () => createSelector([selectAllUsersList], cse => cse.data)
const getAllUsersListError = () => createSelector([selectAllUsersList], cse => cse.error)
const getAllUsersListLoading = () => createSelector([selectAllUsersList], cse => cse.loading)

const selectSingleUser = state => state.userDomain.singleUser
const getSingleUser = () => createSelector([selectSingleUser], cse => cse.data)
const getSingleUserError = () => createSelector([selectSingleUser], cse => cse.error)
const getSingleUserLoading = () => createSelector([selectSingleUser], cse => cse.loading)

const selectUpdateUser = state => state.userDomain.updateUser
const getUpdateUserRes = () => createSelector([selectUpdateUser], cse => cse.data)
const getUpdateUserError = () => createSelector([selectUpdateUser], cse => cse.error)
const getUpdateUserLoading = () => createSelector([selectUpdateUser], cse => cse.loading)

const selectDeleteUser = state => state.userDomain.deleteUser
const getDeleteUserRes = () => createSelector([selectDeleteUser], cse => cse.data)
const getDeleteUserError = () => createSelector([selectDeleteUser], cse => cse.error)
const getDeleteUserLoading = () => createSelector([selectDeleteUser], cse => cse.loading)

const selectAdminDoctorsList = state => state.userDomain.adminDoctorsList
const getAdminDoctorsList = () => createSelector([selectAdminDoctorsList], cse => cse.data)
const getAdminDoctorsListError = () => createSelector([selectAdminDoctorsList], cse => cse.error)
const getAdminDoctorsListLoading = () => createSelector([selectAdminDoctorsList], cse => cse.loading)

const selectAdminDoctor = state => state.userDomain.adminDoctor
const getAdminDoctor = () => createSelector([selectAdminDoctor], cse => cse.data)
const getAdminDoctorError = () => createSelector([selectAdminDoctor], cse => cse.error)
const getAdminDoctorLoading = () => createSelector([selectAdminDoctor], cse => cse.loading)

const selectCreateAdminDoctor = state => state.userDomain.createAdminDoctor
const getCreateAdminDoctor = () => createSelector([selectCreateAdminDoctor], cse => cse.data)
const getCreateAdminDoctorError = () => createSelector([selectCreateAdminDoctor], cse => cse.error)
const getCreateAdminDoctorLoading = () => createSelector([selectCreateAdminDoctor], cse => cse.loading)

const selectUpdateAdminDoctor = state => state.userDomain.updateAdminDoctor
const getUpdateAdminDoctor = () => createSelector([selectUpdateAdminDoctor], cse => cse.data)
const getUpdateAdminDoctorError = () => createSelector([selectUpdateAdminDoctor], cse => cse.error)
const getUpdateAdminDoctorLoading = () => createSelector([selectUpdateAdminDoctor], cse => cse.loading)

const selectAdminPanelUsersList = state => state.userDomain.adminPanelUsersList
const getAdminPanelUsersList = () => createSelector(
  [selectAdminPanelUsersList],
  cse => cse.data,
)
const getAdminPanelUsersListError = () => createSelector(
  [selectAdminPanelUsersList],
  cse => cse.error,
)
const getAdminPanelUsersListLoading = () => createSelector(
  [selectAdminPanelUsersList],
  cse => cse.loading,
)

const selectSingleAdminPanelUser = state => state.userDomain.singleAdminPanelUser
const getSingleAdminPanelUser = () => createSelector(
  [selectSingleAdminPanelUser],
  cse => cse.data,
)
const getSingleAdminPanelUserError = () => createSelector(
  [selectSingleAdminPanelUser],
  cse => cse.error,
)
const getSingleAdminPanelUserLoading = () => createSelector(
  [selectSingleAdminPanelUser],
  cse => cse.loading,
)

const selectCreateAdminPanelUser = state => state.userDomain.createAdminPanelUser
const getCreateAdminPanelUser = () => createSelector(
  [selectCreateAdminPanelUser],
  cse => cse.data,
)
const getCreateAdminPanelUserError = () => createSelector(
  [selectCreateAdminPanelUser],
  cse => cse.error,
)
const getCreateAdminPanelUserLoading = () => createSelector(
  [selectCreateAdminPanelUser],
  cse => cse.loading,
)

const selectUpdateAdminPanelUser = state => state.userDomain.updateAdminPanelUser
const getUpdateAdminPanelUser = () => createSelector(
  [selectUpdateAdminPanelUser],
  cse => cse.data,
)
const getUpdateAdminPanelUserError = () => createSelector(
  [selectUpdateAdminPanelUser],
  cse => cse.error,
)
const getUpdateAdminPanelUserLoading = () => createSelector(
  [selectUpdateAdminPanelUser],
  cse => cse.loading,
)

const selectForgotPassword = state => state.userDomain.forgotPassword
const forgotPassword = () => createSelector([selectForgotPassword], prf => prf.data)
const forgotPasswordError = () => createSelector([selectForgotPassword], prf => prf.error)
const forgotPasswordLoading = () => createSelector([selectForgotPassword], prf => prf.loading)
//
const selectUpdateAdminDoctorStatus = state => state.userDomain.updateAdminDoctorStatus
const getUpdateAdminDoctorStatus = () => createSelector([selectUpdateAdminDoctorStatus], cse => cse.data)
const getUpdateAdminDoctorStatusError = () => createSelector([selectUpdateAdminDoctorStatus], cse => cse.error)
const getUpdateAdminDoctorStatusLoading = () => createSelector([selectUpdateAdminDoctorStatus], cse => cse.loading)

const selectPostAdminDoctorDigitalSig = state => state.userDomain.postAdminDoctorDigitalSig
const getPostAdminDoctorDigitalSig = () => createSelector([selectPostAdminDoctorDigitalSig], cse => cse.data)
const getPostAdminDoctorDigitalSigError = () => createSelector([selectPostAdminDoctorDigitalSig], cse => cse.error)
const getPostAdminDoctorDigitalSigLoading = () => createSelector([selectPostAdminDoctorDigitalSig], cse => cse.loading)

const selectRevokeAdminDoctorDigitalSig = state => state.userDomain.revokeAdminDoctorDigitalSig
const getRevokeAdminDoctorDigitalSig = () => createSelector([selectRevokeAdminDoctorDigitalSig], cse => cse.data)
const getRevokeAdminDoctorDigitalSigError = () => createSelector([selectRevokeAdminDoctorDigitalSig], cse => cse.error)
const getRevokeAdminDoctorDigitalSigLoading = () => createSelector([selectRevokeAdminDoctorDigitalSig], cse => cse.loading)

const selectPostAdminDoctorSpecs = state => state.userDomain.postAdminDoctorSpecs
const getPostAdminDoctorSpecs = () => createSelector([selectPostAdminDoctorSpecs], cse => cse.data)
const getPostAdminDoctorSpecsError = () => createSelector([selectPostAdminDoctorSpecs], cse => cse.error)
const getPostAdminDoctorSpecsLoading = () => createSelector([selectPostAdminDoctorSpecs], cse => cse.loading)

const selectDeleteAdminDoctor = state => state.userDomain.deleteAdminDoctor
const getDeleteAdminDoctorRes = () => createSelector([selectDeleteAdminDoctor], cse => cse.data)
const getDeleteAdminDoctorError = () => createSelector([selectDeleteAdminDoctor], cse => cse.error)
const getDeleteAdminDoctorLoading = () => createSelector([selectDeleteAdminDoctor], cse => cse.loading)

const selectProfile = state => state.userDomain.profile
const profile = () => createSelector([selectProfile], prf => prf.data)
const profileError = () => createSelector([selectProfile], prf => prf.error)
const profileLoading = () => createSelector([selectProfile], prf => prf.loading)

const selectUpdateProfile = state => state.userDomain.updateProfile
const updatedProfile = () => createSelector([selectUpdateProfile], prf => prf.data)
const updatedProfileError = () => createSelector([selectUpdateProfile], prf => prf.error)
const updatedProfileLoading = () => createSelector([selectUpdateProfile], prf => prf.loading)

const selectPostDocDigitalInfo = state => state.userDomain.postDocDigitalInfo
const postDocDigitalInfo = () => createSelector([selectPostDocDigitalInfo], prf => prf.data)
const postDocDigitalInfoError = () => createSelector([selectPostDocDigitalInfo], prf => prf.error)
const postDocDigitalInfoLoading = () => createSelector([selectPostDocDigitalInfo], prf => prf.loading)

const selectUserLogin = state => state.userDomain.userLogin
const userLogin = () => createSelector([selectUserLogin], prf => prf.data)
const userLoginError = () => createSelector([selectUserLogin], prf => prf.error)
const userLoginLoading = () => createSelector([selectUserLogin], prf => prf.loading)

const selectUserRegisteration = state => state.userDomain.userRegisteration
const userRegisteration = () => createSelector([selectUserRegisteration], prf => prf.data)
const userRegisterationError = () => createSelector([selectUserRegisteration], prf => prf.error)
const userRegisterationLoading = () => createSelector([selectUserRegisteration], prf => prf.loading)

const selectAppleLogin = state => state.userDomain.appleLogin
const appleLogin = () => createSelector([selectAppleLogin], prf => prf.data)
const appleLoginError = () => createSelector([selectAppleLogin], prf => prf.error)
const appleLoginLoading = () => createSelector([selectAppleLogin], prf => prf.loading)

const selectLoginGoogle = state => state.userDomain.loginGoogle
const loginGoogle = () => createSelector([selectLoginGoogle], prf => prf.data)
const loginGoogleError = () => createSelector([selectLoginGoogle], prf => prf.error)
const loginGoogleLoading = () => createSelector([selectLoginGoogle], prf => prf.loading)

const selectNumberValidation = state => state.userDomain.validatePhoneNumber
const validatePhoneNumber = () => createSelector([selectNumberValidation], prf => prf.data)
const validatePhoneNumberError = () => createSelector([selectNumberValidation], prf => prf.error)
const validatePhoneNumberLoading = () => createSelector([selectNumberValidation], prf => prf.loading)

const selectLogout = state => state.userDomain.logout
const logoutError = () => createSelector([selectLogout], prf => prf.error)
const logoutLoading = () => createSelector([selectLogout], prf => prf.loading)

const selectUpdateEmail = state => state.userDomain.updateEmail
const updateEmail = () => createSelector([selectUpdateEmail], prf => prf.data)
const updateEmailError = () => createSelector([selectUpdateEmail], prf => prf.error)
const updateEmailLoading = () => createSelector([selectUpdateEmail], prf => prf.loading)

const selectUpdateNumber = state => state.userDomain.updateNumber
const updateNumber = () => createSelector([selectUpdateNumber], prf => prf.data)
const updateNumberError = () => createSelector([selectUpdateNumber], prf => prf.error)
const updateNumberLoading = () => createSelector([selectUpdateNumber], prf => prf.loading)

const selectPasswordChange = state => state.userDomain.changePassword
const changePassword = () => createSelector([selectPasswordChange], prf => prf.data)
const changePasswordError = () => createSelector([selectPasswordChange], prf => prf.error)
const changePasswordLoading = () => createSelector([selectPasswordChange], prf => prf.loading)

const selectMarketplaceChangePassword = state => state.userDomain.marketplaceChangePassword
const marketplaceChangePassword = () => createSelector([selectMarketplaceChangePassword], prf => prf.data)
const marketplaceChangePasswordError = () => createSelector([selectMarketplaceChangePassword], prf => prf.error)
const marketplaceChangePasswordLoading = () => createSelector([selectMarketplaceChangePassword], prf => prf.loading)

const selectGetDoctorDetailsState = state => state.userDomain.getDoctorDetailsState
const getDoctorDetailsData = () => createSelector([selectGetDoctorDetailsState], ss => ss.data)
const getDoctorDetailsDataError = () => createSelector([selectGetDoctorDetailsState], ss => ss.error)
const getDoctorDetailsDataLoading = () => createSelector([selectGetDoctorDetailsState], ss => ss.loading)

const selectGetDoctorIdState = state => state.userDomain.getDoctorIdState
const getDoctorIdData = () => createSelector([selectGetDoctorIdState], ss => ss.data)
const getDoctorIdDataError = () => createSelector([selectGetDoctorIdState], ss => ss.error)
const getDoctorIdDataLoading = () => createSelector([selectGetDoctorIdState], ss => ss.loading)

const selectPostDoctorPin = state => state.userDomain.postDoctorPin
const postDoctorPinData = () => createSelector(
  [selectPostDoctorPin],
  cse => cse.data,
)

const postDoctorPinError = () => createSelector(
  [selectPostDoctorPin],
  cse => cse.error,
)

const postDoctorPinLoading = () => createSelector(
  [selectPostDoctorPin],
  cse => cse.loading,
)

module.exports = {
  getLoggedInUser,
  getLoggedInUserError,
  getLoggedInUserLoading,

  getPostUser,
  getPostUserError,
  getPostUserLoading,

  getImportUser,
  getImportUserError,
  getImportUserLoading,

  getAllUsersList,
  getAllUsersListError,
  getAllUsersListLoading,

  getSingleUser,
  getSingleUserError,
  getSingleUserLoading,

  getUpdateUserRes,
  getUpdateUserError,
  getUpdateUserLoading,

  getDeleteUserRes,
  getDeleteUserError,
  getDeleteUserLoading,

  getAdminDoctorsList,
  getAdminDoctorsListError,
  getAdminDoctorsListLoading,

  getAdminDoctor,
  getAdminDoctorError,
  getAdminDoctorLoading,

  getCreateAdminDoctor,
  getCreateAdminDoctorError,
  getCreateAdminDoctorLoading,

  getUpdateAdminDoctor,
  getUpdateAdminDoctorError,
  getUpdateAdminDoctorLoading,

  getAdminPanelUsersList,
  getAdminPanelUsersListError,
  getAdminPanelUsersListLoading,
  getSingleAdminPanelUser,
  getSingleAdminPanelUserError,
  getSingleAdminPanelUserLoading,
  getCreateAdminPanelUser,
  getCreateAdminPanelUserError,
  getCreateAdminPanelUserLoading,
  getUpdateAdminPanelUser,
  getUpdateAdminPanelUserError,
  getUpdateAdminPanelUserLoading,

  getUpdateAdminDoctorStatus,
  getUpdateAdminDoctorStatusError,
  getUpdateAdminDoctorStatusLoading,

  getPostAdminDoctorDigitalSig,
  getPostAdminDoctorDigitalSigError,
  getPostAdminDoctorDigitalSigLoading,

  getRevokeAdminDoctorDigitalSig,
  getRevokeAdminDoctorDigitalSigError,
  getRevokeAdminDoctorDigitalSigLoading,

  getPostAdminDoctorSpecs,
  getPostAdminDoctorSpecsError,
  getPostAdminDoctorSpecsLoading,

  getDeleteAdminDoctorRes,
  getDeleteAdminDoctorError,
  getDeleteAdminDoctorLoading,

  profile,
  profileLoading,
  profileError,

  updatedProfile,
  updatedProfileLoading,
  updatedProfileError,

  postDocDigitalInfo,
  postDocDigitalInfoError,
  postDocDigitalInfoLoading,

  userLogin,
  userLoginLoading,
  userLoginError,

  userRegisteration,
  userRegisterationLoading,
  userRegisterationError,

  appleLogin,
  appleLoginLoading,
  appleLoginError,

  loginGoogle,
  loginGoogleLoading,
  loginGoogleError,

  validatePhoneNumber,
  validatePhoneNumberLoading,
  validatePhoneNumberError,

  updateEmail,
  updateEmailLoading,
  updateEmailError,

  updateNumber,
  updateNumberLoading,
  updateNumberError,

  logoutError,
  logoutLoading,

  forgotPassword,
  forgotPasswordError,
  forgotPasswordLoading,

  changePassword,
  changePasswordLoading,
  changePasswordError,

  marketplaceChangePassword,
  marketplaceChangePasswordLoading,
  marketplaceChangePasswordError,

  getDoctorDetailsData,
  getDoctorDetailsDataError,
  getDoctorDetailsDataLoading,

  getDoctorIdData,
  getDoctorIdDataError,
  getDoctorIdDataLoading,

  postDoctorPinData,
  postDoctorPinError,
  postDoctorPinLoading,
  
  emailOtp,
  emailOtpLoading,
  emailOtpError,
}